import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, GuidLinkGetters } from './types';

const _getters = namespaceHelper.removeNamespace(namespace, GuidLinkGetters);

export default {
  [_getters.GET_ESTIMATE_LINK]: state => {
    return state.estimateLink;
  },
  [_getters.GET_SERVICE_ORDER]: state => {
    return state.estimateLink;
  },
  [_getters.GET_PARTS_ORDER]: state => {
    return state.estimateLink;
  },
  [_getters.GET_ESTIMATE_LINK_STATUS_MAP]: state => {
    return state.estimateLinkLookups.jobOperationStatusesMap;
  },
  [_getters.GET_UNIT]: state => {
    return state.unit;
  },
  [_getters.GET_PAYMENT_LINK]: state => {
    return state.paymentLink;
  }
};
